<template>
  <div class="teethlist">
    <template v-if="!hasTeeth">
      <slot />
    </template>
    <div :class="['list-group', {'noclick': !editable}]" v-if="hasTeeth">
      <template v-for="tooth in teeth">
        <div>
          <a class="list-group-item" v-on:click="setPriceVisibility(tooth)">
            <i v-if="showPrices && !tooth.loading"
               :class="tooth.expanded ? 'fa fa-angle-down' : 'fa fa-angle-right'"
               aria-hidden="true">
            </i>
            <i v-if="showPrices && tooth.loading" class="fas fa-spinner fa-spin" aria-hidden="true" />
            <span class="badge">{{ tooth.rangeLabel }}</span>
            <span class="badge" :style="{'background-color': tooth.color}">{{ tooth.material }}</span>
            {{ tooth.itemName }}
            <div v-if="showPrices && tooth.expanded && tooth.priceList" class="priceContainer">
              <div v-for="price in tooth.priceList" class="priceLine">
                <span class="priceName">{{ price.name }}</span>
                <span v-if="price.amount > 1" class="priceName">&nbsp;{{ '(' + price.amount + ' pcs.)' }}</span>
                <span class="priceValue">{{ price.nettotal | formatCurrency}}</span>
              </div>
              <div v-if="tooth.priceList.length > 1" class="priceLine priceTotal">
                <span class="priceName">{{ $t('Common.total') }}</span>
                <span class="priceValue">{{ tooth.priceTotal | formatCurrency }}</span>
              </div>
            </div>
          </a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    teeth: {
      type: Array,
      default() {
        return [];
      }
    },
    editable: {
      type: Boolean,
      default: true
    },
    showPrices: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasTeeth() {
      return this.teeth.length > 0;
    }
  },
  methods: {
    setPriceVisibility(tooth) {
      if (!this.showPrices) {
        return;
      }

      delete tooth.priceList;
      this.$set(tooth, 'expanded', !tooth.expanded);
      if (tooth.expanded) {
        tooth.loading = true;
        this.$http.post(this.$root.url + 'cart/', {
          items: [{
            title: tooth.itemName + ' ' + tooth.rangeLabel,
            id: 'teeth',
            items: tooth.itemnums
          }],
          withDueDate: true
        }).then(function (res) {
          tooth.loading = false;
          if (res.data.result && res.data.result.items) {
            this.$set(tooth, 'priceList', res.data.result.items.filter(item => item && item.type == 0));
            this.$set(tooth, 'priceTotal', tooth.priceList.reduce((sum, a) => sum + (a.nettotal || 0), 0));
          }
        }.bind(this));
      }
    }
  }
}

</script>
<style scoped>
  div.priceContainer {
    overflow-y: auto;
    margin-top: 5px;
  }
  .list-group-item i.fa {
    width: 10px;
  }
  .priceTotal {
    font-weight: bold;
  }
  .priceLine {
    clear: both;
  }
  .priceName {
    float: left;
  }
  .priceValue {
    float: right;
  }
</style>